var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-type-teaser",class:{ active: _vm.component.ready }},[_c('img',{attrs:{"src":_vm.component.img_url}}),_c('h5',[_vm._v(_vm._s(_vm.$t(_vm.component.title)))])])}
var staticRenderFns = []

export { render, staticRenderFns }